import { render, staticRenderFns } from "./PermissionConfiguration.vue?vue&type=template&id=0dfe308e&scoped=true&"
import script from "./PermissionConfiguration.vue?vue&type=script&lang=js&"
export * from "./PermissionConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PermissionConfiguration.vue?vue&type=style&index=0&id=0dfe308e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe308e",
  null
  
)

export default component.exports